export const CURRENCY_SGD = 'SGD' as const;
